/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as components from "../components/index.js";

export type PreconditionFailedErrorResponseData = {
  meta: components.Meta;
  error: components.BaseError;
};

export class PreconditionFailedErrorResponse extends Error {
  meta: components.Meta;
  error: components.BaseError;

  /** The original data that was passed to this error instance. */
  data$: PreconditionFailedErrorResponseData;

  constructor(err: PreconditionFailedErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.meta = err.meta;
    this.error = err.error;

    this.name = "PreconditionFailedErrorResponse";
  }
}

/** @internal */
export const PreconditionFailedErrorResponse$inboundSchema: z.ZodType<
  PreconditionFailedErrorResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: components.Meta$inboundSchema,
  error: components.BaseError$inboundSchema,
})
  .transform((v) => {
    return new PreconditionFailedErrorResponse(v);
  });

/** @internal */
export type PreconditionFailedErrorResponse$Outbound = {
  meta: components.Meta$Outbound;
  error: components.BaseError$Outbound;
};

/** @internal */
export const PreconditionFailedErrorResponse$outboundSchema: z.ZodType<
  PreconditionFailedErrorResponse$Outbound,
  z.ZodTypeDef,
  PreconditionFailedErrorResponse
> = z.instanceof(PreconditionFailedErrorResponse)
  .transform(v => v.data$)
  .pipe(z.object({
    meta: components.Meta$outboundSchema,
    error: components.BaseError$outboundSchema,
  }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PreconditionFailedErrorResponse$ {
  /** @deprecated use `PreconditionFailedErrorResponse$inboundSchema` instead. */
  export const inboundSchema = PreconditionFailedErrorResponse$inboundSchema;
  /** @deprecated use `PreconditionFailedErrorResponse$outboundSchema` instead. */
  export const outboundSchema = PreconditionFailedErrorResponse$outboundSchema;
  /** @deprecated use `PreconditionFailedErrorResponse$Outbound` instead. */
  export type Outbound = PreconditionFailedErrorResponse$Outbound;
}
